import React, { Component } from "react";
import Layout from "./components/Layout";
import keycloak from "../keycloak";

class AddUser extends Component {
  constructor(props) {
    super(props);

    this.state = {
      username: "",
      email: "",
      firstName: "",
      lastName: "",
      enabled: true,
      emailVerified: true,
    };
  }

  componentDidMount() {
    console.log("keycloak details", keycloak);
    const fetchRealm = async () => {
      try {
        console.log(
          "URL",
          `${keycloak.authServerUrl}/admin/realms/${keycloak.realm}/clients`
        );
        const response = await fetch(
          `https://oxdr-sso.invinsense.io/admin/realms/${keycloak.realm}/clients?clientId=${keycloak.clientId}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${keycloak.token}`,
            },
          }
        );

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();

        const clientId = data[0]?.id;
        if (clientId) {
          await getClientRoles(clientId);
        }
        console.log("Fetched clients:", data);
      } catch (error) {
        console.log("Error fetching clients:", error);
      }
    };

    const getClientRoles = async (clientId) => {
      try {
        const response = await fetch(
          `https://oxdr-sso.invinsense.io/admin/realms/${keycloak.realm}/clients/${clientId}/roles`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${keycloak.token}`,
            },
          }
        );

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        console.log("Fetched roles:", data);
      } catch (error) {
        console.log("error", error);
      }
    };
    fetchRealm();
  }

//   createUser = async () => {
//     const userDetails = {
//       username: "api1",
//       email: "apiUser1@example.com",
//       firstName: "Api1",
//       lastName: "User",
//       enabled: true,
//       emailVerified: true,
//       credentials: [
//         {
//           type: "password",
//           value: "Admin@123",
//           temporary: false,
//         },
//       ],
//     };

//     try {
//       const url = `https://oxdr-sso.invinsense.io/admin/realms/${keycloak.realm}/users`;

//       const response = await fetch(url, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${keycloak.token}`,
//         },
//         body: JSON.stringify(userDetails),
//       });

//       if (!response.ok) {
//         throw new Error(`HTTP error! Status: ${response.status}`);
//       }

//       console.log("User created successfully!", response);
//     } catch (error) {
//       console.error("Error creating user:", error);
//     }
//   };

  handleInputChange = (event) => {
    const { name, value } = event.target;
    this.setState({
      [name]: value,
    });
  };

  handleSubmit = async (event) => {
    event.preventDefault();

    const { username, email, firstName, lastName, enabled, emailVerified } = this.state;
    const userDetails = {
      username,
      email,
      firstName,
      lastName,
      enabled,
      emailVerified,
      credentials: [
        {
          type: "password",
          value: "Admin@123",
          temporary: false
        }
      ]
    };

    try {
      const url = `https://oxdr-sso.invinsense.io/admin/realms/${keycloak.realm}/users`;
      
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${keycloak.token}`
        },
        body: JSON.stringify(userDetails)
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      alert("User created!")
      this.setState({username:'', email:'',firstName:'',lastName:''});
      console.log("User created successfully!",response);
    } catch (error) {
      console.error("Error creating user:", error);
    }
  };

  render() {
    return (
      <section className="dashboard">
        <Layout>
          <div>
            <div>
              <h2>Create New User</h2>
              <form onSubmit={this.handleSubmit}>
                <label>
                  Username:
                  <input
                    type="text"
                    name="username"
                    value={this.state.username}
                    onChange={this.handleInputChange}
                    required
                  />
                </label>
                <br />

                <label>
                  Email:
                  <input
                    type="email"
                    name="email"
                    value={this.state.email}
                    onChange={this.handleInputChange}
                    required
                  />
                </label>
                <br />

                <label>
                  First Name:
                  <input
                    type="text"
                    name="firstName"
                    value={this.state.firstName}
                    onChange={this.handleInputChange}
                    required
                  />
                </label>
                <br />

                <label>
                  Last Name:
                  <input
                    type="text"
                    name="lastName"
                    value={this.state.lastName}
                    onChange={this.handleInputChange}
                    required
                  />
                </label>
                <br />

                <button type="submit">Create User</button>
              </form>
            </div>
          </div>
        </Layout>
      </section>
    );
  }
}

export default AddUser;
